import { TASK_CONTEXT_MENU_SERVICE_NAME, TaskContextMenuServiceProvider } from './task.context-menu.service'
import { TASK_SERVICE_NAME, TaskServiceProvider } from './task.service'
import { TASK_TECHNICAL_PERMISSIONS_SERVICE_NAME, TaskTechnicalPermissionsServiceProvider } from './task.technical-permissions.service'

export const TASK_SERVICES_MODULE_NAME = 'simax.services.task'

const module = angular.module(TASK_SERVICES_MODULE_NAME, [])

module.provider(TASK_CONTEXT_MENU_SERVICE_NAME, TaskContextMenuServiceProvider)
module.provider(TASK_SERVICE_NAME, TaskServiceProvider)
module.provider(TASK_TECHNICAL_PERMISSIONS_SERVICE_NAME, TaskTechnicalPermissionsServiceProvider)
